import BaseRouter from '../components/base-router'
import DocumentsOverview from './documents-overview'
import DocumentsFolderView from './documents-folder-overview'
import File from 'scoreboard/components/files/file'
import appDisplay from 'scoreboard/components/app-display'
import Nav from './documents-nav'
import viewEditTabs from 'scoreboard/components/view-edit-tabs.hbs'
import FolderForm from 'scoreboard/components/folder-form'
import DocumentsEdit from './documents-edit'
import noPermission from 'scoreboard/components/no-permission.hbs'
import EmptyState from 'scoreboard/components/empty-state'
import getCreateFolderFunction from 'scoreboard/components/get-create-folder-function'

var DocumentsRouter = BaseRouter.extend({

	 routes: {
	 	'files/:id(/)': 'overview',
	 	'files/:id/edit(/)': 'edit',
	 	'files/:id/new-folder(/)': 'createFolder'
	 },

	Nav: Nav,
	Model: File,
	section: 'files',

	// the overview route, which retrieves a doc by ID and then displays the
	// overview
	overview: function(id) {
		let options = { datasets: true, imports: true }
		const modelPromise = this.load(id, options)
		appDisplay.display(modelPromise, function(model) {
			var View = model.get('type') == 'folder' ? DocumentsFolderView : DocumentsOverview
			return new View({ model: model, tabs: viewEditTabs, overviewTabCode: 'common.view' })
		})
		this.navForModel({ id }, modelPromise)
	},

	edit: function(id) {
		const modelPromise = this.load(id)
		appDisplay.display(modelPromise, model => {
			if (!model.isEditable()) {
				return new EmptyState({body: noPermission()})
			}

			var View = model.get('type') == 'folder' ? FolderForm : DocumentsEdit
			return new View({ model, tabs: viewEditTabs, overviewTabCode: 'common.overview' })
		})
		this.navForModel({id, edit: true}, modelPromise)
	},

	createFolder: getCreateFolderFunction(false)

})

export default DocumentsRouter

DocumentsRouter.__filename__ = 'documents/documents-router.js'
